module.exports = __webpack_public_path__ + "img/首图英文.4d086b40.png";